import React, {Component} from 'react';
import {Accordion, Card} from 'react-bootstrap';

export default class ErrorBoundary extends Component{

	constructor(props){
		super(props);
		this.state = {hasError: false};
	}

	componentDidCatch(error, info){
		this.setState({
			hasError: true,
			errorObj: error,
			errorStack: info
		});
	}

	getStack = () => {
		let {
			hasError,
			errorStack,
			errorObj
		} = this.state;
		return {
			__html: errorStack.componentStack
				.trim()
				.replace(/\n/g, "<br/>")
		};
	}

	getErrorString = () => {
		let {errorObj} = this.state;
		return errorObj.toString();
	}

	render(){
		let {hasError} = this.state;

		return hasError ? (
			<div className="error-boundary">
				<h1>Error</h1>
				<h3><span>{
					this.getErrorString()
				}</span></h3>
				<Accordion className="subtle-panel">
					<Accordion.Item eventKey="0">
						<Accordion.Header>stack</Accordion.Header>
						<Accordion.Body>
							<pre dangerouslySetInnerHTML={
								this.getStack()
							}/>
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</div>
		) : this.props.children;
	}

}
